// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__K3sfu","container":"styles_container__gaD-K","title":"styles_title__3kSR3","wrapper":"styles_wrapper__1tzFB","answer":"styles_answer__1TLQD"};